function convertZeroToTruthy(value) {
    return value === 0 ? '0' : value;
}

export default convertZeroToTruthy;
